import { useQuery } from '@tanstack/react-query';

import { getAllByUserIds } from '../api/ventura/reportTemplates';
import { camelCaseKeys } from '../util/object';

function useReportTemplates(apiHost: string, userIds: number[]) {
  const reportTemplates = useQuery({
    // TODO: fix the queryKey
    queryKey: ['reportTemplatesByUser', userIds.join(',')],
    queryFn: () => getAllByUserIds(apiHost, userIds),
    select: camelCaseKeys,
  });

  return reportTemplates;
}

export default useReportTemplates;
